import { Badge } from "../../../../shared";
import { formatDate } from "../../../../utils";
import {
  formatComplianceRelative,
  getComplianceDateBadgeColor,
  getComplianceDateStatus,
} from "../../../../utils/equipmentCompliance";

/**
 * Read-only compliance date with status badge and relative hint.
 */
export const ComplianceDateField = ({ label, date }) => {
  const status = getComplianceDateStatus(date);
  const badgeLabel =
    status === "expired"
      ? "Expired"
      : status === "warning"
        ? "Due soon"
        : status === "ok"
          ? "OK"
          : "Not set";

  return (
    <div>
      <p className="text-sm font-medium text-gray-500">{label}</p>
      <div className="mt-1 flex flex-wrap items-center gap-2">
        <span className="text-gray-900">
          {date ? formatDate(date) : "—"}
        </span>
        {status !== "none" ? (
          <Badge label={badgeLabel} color={getComplianceDateBadgeColor(status)} />
        ) : null}
      </div>
      <p className="mt-0.5 text-xs text-gray-500">
        {formatComplianceRelative(date)}
      </p>
    </div>
  );
};

export default ComplianceDateField;
